(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ym-maker-directory"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ym-maker-trigger > a').forEach(function (trigger) {
    function sizePanel() {
      var panel = trigger.parentElement.querySelector('.ym-maker-panel');
      if (panel) panel.style.maxHeight = Math.max(180, window.innerHeight - trigger.getBoundingClientRect().bottom - 18) + 'px';
    }
    trigger.addEventListener('click', function (event) { event.preventDefault(); sizePanel(); });
    trigger.addEventListener('mouseenter', sizePanel);
    trigger.addEventListener('focus', sizePanel);
    window.addEventListener('resize', sizePanel);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-native-content-runtime"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ym-native-content [data-ym-link]').forEach(function (panel) {
    function activate(event) {
      if (event.target.closest('a,button,input,select,textarea,summary')) return;
      if (event.type === 'keydown' && event.key !== 'Enter') return;
      var target = panel.dataset.ymLink;
      if (!target || !/^(https?:\/\/|\/|#)/i.test(target)) return;
      event.preventDefault();
      if (panel.dataset.ymNewWindow === 'true') window.open(target, '_blank', 'noopener');
      else window.location.assign(target);
    }
    panel.addEventListener('click', activate);
    panel.addEventListener('keydown', activate);
  });
  document.querySelectorAll('.ym-native-content .ymn-image-lightbox-content img').forEach(function (image) {
    if (image.closest('a,[data-ym-link]') || !image.src) return;
    var link = document.createElement('a');
    link.href = image.src;
    link.target = '_blank';
    link.rel = 'noopener';
    image.before(link);
    link.appendChild(image);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-native-media-runtime"] && !Shopify.designMode) return;
  try {
    function initializeNativeMedia(){
  document.querySelectorAll('.ym-media-description').forEach(function(root){
    if(root.dataset.ymMediaReady)return;
    root.dataset.ymMediaReady='true';
    root.querySelectorAll('.ym-media-accordion').forEach(function(accordion){
      var heading=accordion.querySelector('.ym-media-accordion-heading');var body=accordion.querySelector('.ym-media-accordion-body');if(!heading||!body)return;
      heading.setAttribute('role','button');heading.tabIndex=0;
      function sync(){var open=accordion.classList.contains('ym-media-accordion-active');heading.setAttribute('aria-expanded',String(open));body.classList.toggle('ym-media-accordion-active',open);}
      function toggle(event){if(event.target.closest('a,button,input,select,textarea'))return;if(event.type==='keydown'&&event.key!=='Enter'&&event.key!==' ')return;event.preventDefault();accordion.classList.toggle('ym-media-accordion-active');sync();}
      heading.addEventListener('click',toggle);heading.addEventListener('keydown',toggle);sync();
    });
    root.querySelectorAll('.ym-media-sld').forEach(function(slider){
      var slides=Array.from(slider.querySelectorAll('.ym-media-sld-slides > .ym-media-sld-item'));
      var dots=Array.from(slider.querySelectorAll('.ym-media-sld-dot'));
      if(!slides.length)return;
      var current=0;
      function show(index){current=(index+slides.length)%slides.length;slides.forEach(function(slide,i){slide.classList.toggle('ym-media-sld-active',i===current);slide.setAttribute('aria-hidden',String(i!==current));});dots.forEach(function(dot,i){dot.classList.toggle('ym-media-sld-active',i===current);dot.setAttribute('aria-pressed',String(i===current));});}
      dots.forEach(function(dot,i){dot.setAttribute('role','button');dot.tabIndex=0;dot.setAttribute('aria-label','画像スライド '+(i+1));dot.addEventListener('click',function(){show(i);});dot.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();show(i);}});});
      slider.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}});
      var startX=null;slider.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;},{passive:true});slider.addEventListener('touchend',function(e){if(startX===null)return;var delta=e.changedTouches[0].clientX-startX;if(Math.abs(delta)>40)show(current+(delta<0?1:-1));startX=null;},{passive:true});
      show(0);
    });
    root.querySelectorAll('[data-ym-link]').forEach(function(panel){
      function activate(event){
        if(event.target.closest('a,button,input,select,textarea,summary'))return;
        if(event.type==='keydown'&&event.key!=='Enter')return;
        var target=panel.dataset.ymLink;
        if(!target||!/^(https?:\/\/|\/|#)/i.test(target))return;
        event.preventDefault();
        if(panel.dataset.ymNewWindow==='true')window.open(target,'_blank','noopener');
        else window.location.assign(target);
      }
      panel.addEventListener('click',activate);panel.addEventListener('keydown',activate);
    });
    var images=Array.from(root.querySelectorAll('.ym-media-image-lightbox-content img')).filter(function(img){return img.src&&!img.closest('a');});
    if(!images.length)return;
    var dialog=document.createElement('dialog');
    dialog.setAttribute('aria-label','拡大画像');
    var close=document.createElement('button');close.type='button';close.className='ym-media-close';close.textContent='閉じる';
    var enlarged=document.createElement('img');
    var controls=document.createElement('div');controls.className='ym-media-gallery-controls';
    var previous=document.createElement('button');previous.type='button';previous.textContent='前の画像';
    var next=document.createElement('button');next.type='button';next.textContent='次の画像';
    controls.append(previous,next);dialog.append(close,enlarged,controls);root.append(dialog);
    var current=0;
    function show(index){current=(index+images.length)%images.length;enlarged.src=images[current].src;enlarged.alt=images[current].alt||'';controls.hidden=images.length<2;}
    close.addEventListener('click',function(){dialog.close();});
    previous.addEventListener('click',function(){show(current-1);});next.addEventListener('click',function(){show(current+1);});
    dialog.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}});
    dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    images.forEach(function(img,index){var link=document.createElement('a');link.href=img.src;link.target='_blank';link.rel='noopener';link.setAttribute('aria-label',img.alt?img.alt+'（拡大）':'画像を拡大');img.before(link);link.append(img);link.addEventListener('click',function(e){if(e.ctrlKey||e.metaKey||e.shiftKey||!dialog.showModal)return;e.preventDefault();show(index);dialog.showModal();close.focus();});});
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeNativeMedia);else initializeNativeMedia();
document.addEventListener('shopify:section:load',initializeNativeMedia);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-native-product-widgets"] && !Shopify.designMode) return;
  try {
    function initializeNativeProductWidgets(){
  document.querySelectorAll('script.ym-widget-config').forEach(function(node){
    if(node.dataset.ready)return;
    var config;
    try{config=JSON.parse(node.textContent);}catch(error){return;}
    var box=document.getElementById(config.id);
    if(!box)return;
    node.dataset.ready='true';
    var product=config.product;
    if(!product||!Array.isArray(product.variants)||!product.variants.length){box.hidden=true;return;}
    box.hidden=false;box.style.display='block';
    var variants=product.variants;
    variants.forEach(function(v){if(!Array.isArray(v.options))v.options=[v.option1,v.option2,v.option3].filter(function(x){return x!==null&&x!==undefined;});});
    var selected=variants.find(function(v){return String(v.id)===String(config.variantId);})||variants.find(function(v){return v.available;})||variants[0];
    var callbacks=config.callbacks||[];
    var variantConfig=callbacks.find(function(c){return c.cb==='variant';});
    var quantityConfig=callbacks.find(function(c){return c.cb==='quantity';});
    var priceConfig=callbacks.find(function(c){return c.cb==='price';});
    var addConfig=callbacks.find(function(c){return c.cb==='addToCart';});
    var options=(product.options||[]).map(function(o){return typeof o==='string'?o:o.name;});
    var mounts=Array.from(box.querySelectorAll('[data-ym-media-product-target="product-variant-mount"]'));
    var quantity=box.querySelector('[data-ym-media-product-target="product-quantity"]');
    if(quantity){quantity.value=String(quantityConfig&&quantityConfig.data.defaultQuantity||1);quantity.min='1';quantity.step='1';quantity.setAttribute('aria-label','数量');}
    var selectors=[];
    var galleryImages=[];
    function money(value){return '¥'+Math.round(Number(value||0)/100).toLocaleString('ja-JP');}
    function source(image){return typeof image==='string'?image:image&&(image.src||image.url)||'';}
    function imageSource(){return source(selected.featured_image)||source(product.featured_image)||source((product.images||[])[0]);}
    function targets(type){return Array.from(box.querySelectorAll('[data-ym-media-product-target="'+type+'"]'));}
    function refresh(){
      targets('product-title').forEach(function(el){el.textContent=product.title;});
      targets('product-price').forEach(function(el){el.textContent=selected?money(selected.price):'';});
      targets('product-compare-price').forEach(function(el){var show=selected&&priceConfig&&priceConfig.data.hasComparePrice&&selected.compare_at_price>selected.price;el.textContent=show?money(selected.compare_at_price):'';el.style.display=show?'':'none';});
      targets('product-sold-out').forEach(function(el){el.style.display=selected&&selected.available?'none':'';});
      var src=selected?imageSource():'';
      targets('product-image').concat(galleryImages).forEach(function(img){if(src)img.src=src;img.alt=product.title;});
      if(addConfig){var button=document.getElementById(addConfig.data.uuid);if(button){var available=selected&&selected.available;button.textContent=!selected?addConfig.data.unavailableText:available?addConfig.data.buttonText:addConfig.data.soldOutText;button.setAttribute('aria-disabled',String(!available));}}
      box.dataset.ymSelectedVariant=selected?String(selected.id):'';
      box.querySelectorAll('form').forEach(function(form){var hidden=form.querySelector('input[name="id"]');if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='id';form.append(hidden);}hidden.value=selected?String(selected.id):'';});
    }
    mounts.forEach(function(mount){
      mount.replaceChildren();
      if(!variantConfig)return;
      var separate=variantConfig.data.groupBy==='separately';
      var count=separate?options.length:1;
      for(var index=0;index<count;index++){
        var select=document.createElement('select');select.className='ym-media-product-selector';select.dataset.optionIndex=String(index);select.setAttribute('aria-label',separate?options[index]:'種類');
        if(variantConfig.data.showVariantLabels){var label=document.createElement('label');label.textContent=separate?options[index]:'種類';select.id=config.id+'-option-'+index;label.htmlFor=select.id;mount.append(label);}
        if(separate){var values=Array.from(new Set(variants.map(function(v){return v.options[index];})));values.forEach(function(value){var option=document.createElement('option');option.value=value;option.textContent=value;option.selected=selected.options[index]===value;select.append(option);});}
        else variants.forEach(function(v){var option=document.createElement('option');option.value=String(v.id);option.textContent=v.title;option.selected=v.id===selected.id;select.append(option);});
        selectors.push(select);mount.append(select);
        select.addEventListener('change',function(){if(separate){var chosen=selectors.map(function(s){return s.value;});selected=variants.find(function(v){return v.options.every(function(value,i){return value===chosen[i];});});}else selected=variants.find(function(v){return String(v.id)===this.value;},this);refresh();});
      }
    });
    box.querySelectorAll('.ym-media-product-quantity-button-left,.ym-media-product-quantity-button-right').forEach(function(button){button.addEventListener('click',function(e){e.preventDefault();if(!quantity)return;var delta=button.classList.contains('ym-media-product-quantity-button-left')?-1:1;quantity.value=String(Math.max(1,(parseInt(quantity.value,10)||1)+delta));});});
    callbacks.filter(function(c){return c.cb==='image_gallery';}).forEach(function(c){
      var container=document.getElementById(c.data.uuid);if(!container)return;
      var gallery=document.createElement('div');var main=document.createElement('img');main.style.maxWidth='100%';galleryImages.push(main);gallery.append(main);
      var thumbs=document.createElement('div');thumbs.className='ym-native-widget-thumbnails';(product.images||[]).forEach(function(image,i){var url=source(image);if(!url)return;var button=document.createElement('button');button.type='button';button.setAttribute('aria-label','商品画像 '+(i+1));var thumb=document.createElement('img');thumb.src=url;thumb.alt='';button.append(thumb);button.addEventListener('click',function(){main.src=url;});thumbs.append(button);});gallery.append(thumbs);container.replaceChildren(gallery);
    });
    if(addConfig){
      var button=document.getElementById(addConfig.data.uuid);
      var form=button&&button.closest('form');
      if(button&&form){
        button.setAttribute('role','button');button.tabIndex=0;
        var status=document.createElement('p');status.className='ym-native-widget-status';status.setAttribute('role','status');form.append(status);
        var busy=false;
        async function submit(event){
          event.preventDefault();if(busy||!selected||!selected.available)return;
          var amount=quantity?Math.max(1,parseInt(quantity.value,10)||1):1;
          busy=true;button.setAttribute('aria-disabled','true');status.textContent='';
          try{var response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:selected.id,quantity:amount})});var result=await response.json();if(!response.ok)throw Error(result.description||result.message||'カートへの追加に失敗しました');status.textContent=addConfig.data.successText;document.dispatchEvent(new CustomEvent('cart:updated',{detail:result}));}
          catch(error){status.textContent=error.message;}
          finally{busy=false;refresh();}
        }
        form.addEventListener('submit',submit);button.addEventListener('click',submit);button.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' ')submit(e);});
      }
    }
    refresh();
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeNativeProductWidgets);else initializeNativeProductWidgets();
document.addEventListener('shopify:section:load',initializeNativeProductWidgets);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-shipping-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-shipping-choice')) {
    customElements.define('ym-shipping-choice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.onChoiceChange = (event) => {
          if (event.target.matches('[data-backorder-ack]')) {
            this.querySelector('[data-backorder-ack-value]').value = event.target.checked ? 'confirmed' : '';
            this.querySelector('[data-ack-error]').hidden = true;
            this.updateEligibility();
            return;
          }
          if (!event.target.matches('input[type="radio"]')) return;
          const mode = event.target.value;
          this.dataset.mode = mode;
          const preferenceInput = this.querySelector('[data-reset-preference]');
          if (preferenceInput) preferenceInput.value = mode;
          this.querySelectorAll('[data-plan]').forEach((panel) => { panel.hidden = panel.dataset.plan !== mode; });
        };
        this.addEventListener('change', this.onChoiceChange);
        if (this.hasAttribute('data-demo')) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.quantityInputs = Array.from(this.form.querySelectorAll('[data-ym-line-key]'));
        this.originalQuantities = this.quantityInputs.map((input) => input.value);
        this.checkout = this.form.querySelector('[data-ym-checkout]');
        this.status = this.querySelector('[data-launch-status]');
        this.reload = this.querySelector('[data-launch-reload]');
        this.busy = false;
        try { this.reviewed = JSON.parse(this.querySelector('[data-ym-stock-state]').textContent); }
        catch (_) { this.showStatus(this.dataset.error, true); return; }
        this.checkQuantities = () => {
          if (this.quantityInputs.some((input, index) => input.value !== this.originalQuantities[index])) this.invalidateChoice();
        };
        this.onCartClick = (event) => {
          if (event.target.closest('.qtyBtn')) requestAnimationFrame(this.checkQuantities);
          if (event.target.closest('.cart__remove')) this.invalidateChoice();
        };
        this.onSubmit = (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.saveChanges();
        };
        this.onCheckout = (event) => {
          if (this.replaying === event.currentTarget) return;
          event.preventDefault(); event.stopImmediatePropagation(); this.beginCheckout(event.currentTarget);
        };
        this.onPageShow = (event) => { if (event.persisted) { this.busy = false; this.invalidateChoice(true, true); } };
        this.onServiceReady = () => this.enableWhenReady();
        this.form.addEventListener('input', this.checkQuantities);
        this.form.addEventListener('change', this.checkQuantities);
        this.form.addEventListener('click', this.onCartClick);
        this.form.addEventListener('submit', this.onSubmit, true);
        this.checkout.addEventListener('click', this.onCheckout);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('ym:shipping-ready', this.onServiceReady);
        if (window.jQuery) window.jQuery(this.form).on('change.ymShippingChoice', this.checkQuantities);
        if (window.YMShipping) this.enableWhenReady();
      }
      async enableWhenReady() {
        try {
          window.YMShipping.validateState(this.reviewed);
          await window.YMShipping.ready;
          this.ready = true;
          this.updateEligibility();
        } catch (_) { this.showStatus(this.dataset.error, true); }
      }
      updateEligibility() {
        if (!this.checkout) return;
        const ack = this.querySelector('[data-backorder-ack]');
        this.checkout.disabled = this.busy || !this.ready || this.dataset.dirty === 'true' || Boolean(ack && !ack.checked);
        this.checkout.setAttribute('aria-disabled', String(this.checkout.disabled));
        const net = this.form.querySelector('#wh-30-open');
        if (net) net.setAttribute('aria-disabled', String(this.checkout.disabled));
      }
      showStatus(message, failed = false) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.hidden = false;
        this.reload.hidden = !failed;
        if (failed) this.status.focus();
      }
      lock() {
        this.busy = true;
        this.controls = Array.from(this.form.querySelectorAll('input,button,textarea,select,fieldset')).map((control) => [control, control.disabled]);
        this.controls.forEach(([control]) => { control.disabled = true; });
        this.checkout.setAttribute('aria-disabled', 'true');
        this.showStatus(this.dataset.loading);
      }
      unlock() {
        (this.controls || []).forEach(([control, disabled]) => { control.disabled = disabled; });
        this.busy = false;
        this.updateEligibility();
      }
      getNote() {
        const note = this.form.querySelector('[name="note"]');
        return note ? note.value : undefined;
      }
      async saveChanges() {
        if (this.busy || !window.YMShipping || window.YMShipping.checkoutBusy) return;
        if (this.reloadOnly) { window.location.assign(window.YMShipping.cartUrl); return; }
        const updates = {};
        try {
          this.quantityInputs.forEach((input) => {
            if (!/^\d+$/.test(input.value.trim())) throw new Error('INVALID_QUANTITY');
            updates[input.dataset.ymLineKey] = Number(input.value);
          });
          const note = this.getNote();
          this.lock();
          await window.YMShipping.saveCart(updates, note);
          window.location.assign(window.YMShipping.cartUrl);
        } catch (_) { this.unlock(); this.showStatus(this.dataset.error, true); }
      }
      async beginCheckout(target = this.checkout, submitter) {
        if (this.busy || !window.YMShipping || window.YMShipping.checkoutBusy) return;
        this.checkQuantities();
        if (this.dataset.dirty === 'true') { await this.saveChanges(); return; }
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack && !ack.checked) {
          const error = this.querySelector('[data-ack-error]');
          error.hidden = false;
          error.focus();
          return;
        }
        const selected = this.querySelector('input[type="radio"]:checked');
        const preference = selected ? selected.value : 'together';
        const acknowledged = Boolean(ack && ack.checked);
        const note = this.getNote();
        this.lock();
        window.YMShipping.checkoutBusy = true;
        try {
          await window.YMShipping.ready;
          const fresh = await window.YMShipping.handoff(this.reviewed, preference, acknowledged, note);
          window.YMShipping.canonicalAttributes(this.form, fresh.attributes);
          const isNetForm = target instanceof HTMLFormElement;
          const isNetOpen = target.id === 'wh-30-open';
          if (!isNetForm && !isNetOpen && target === this.checkout) {
            let checkoutForm = document.querySelector('[data-ym-checkout-only]');
            if (!checkoutForm) {
              checkoutForm = document.createElement('form');
              checkoutForm.method = 'post';
              checkoutForm.action = window.YMShipping.cartUrl;
              checkoutForm.id = 'ym-guarded-checkout-form';
              checkoutForm.hidden = true;
              checkoutForm.setAttribute('data-ym-checkout-only', '');
              document.body.appendChild(checkoutForm);
            }
            this.checkout.type = 'submit';
            this.checkout.setAttribute('form', checkoutForm.id);
          }
          this.unlock();
          this.replaying = target;
          window.YMShipping.allowOriginalOnce(target);
          if (isNetForm) target.requestSubmit(submitter || undefined);
          else target.click();
          this.replaying = null;
          window.YMShipping.checkoutBusy = false;
          this.status.hidden = true;
        } catch (error) {
          try { await window.YMShipping.invalidate(); } catch (_) {}
          window.YMShipping.checkoutBusy = false;
          this.unlock();
          this.invalidateChoice(true, true);
          this.showStatus(error.message === 'REVIEW_CHANGED' ? this.dataset.changed : this.dataset.error, true);
        }
      }
      clearAcknowledgement() {
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack) ack.checked = false;
        const value = this.querySelector('[data-backorder-ack-value]');
        if (value) value.value = '';
      }
      invalidateChoice(persist = true, reloadOnly = false) {
        if (this.hasAttribute('data-demo') || !this.form) return;
        this.reloadOnly = this.reloadOnly || reloadOnly;
        this.dataset.dirty = 'true';
        this.dataset.mode = 'together';
        this.clearAcknowledgement();
        const ack = this.querySelector('[data-backorder-ack]');
        if (ack) ack.disabled = true;
        const fieldset = this.querySelector('fieldset');
        if (fieldset) fieldset.disabled = true;
        this.querySelectorAll('[data-plan]').forEach((panel) => { panel.hidden = true; });
        this.querySelector('[data-cart-changed]').hidden = false;
        const fallback = this.querySelector('[data-reset-preference]');
        fallback.name = 'attributes[ym_shipping_preference]';
        fallback.value = 'together';
        fallback.disabled = false;
        if (window.YMShipping) window.YMShipping.resetLocalAttributes(this.form);
        this.form.querySelectorAll('[data-cart-stock-warning]').forEach((warning) => { warning.hidden = true; });
        this.updateEligibility();
        if (persist && window.YMShipping && !window.YMShipping.checkoutBusy) window.YMShipping.invalidate().catch(() => this.showStatus(this.dataset.error, true));
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChoiceChange);
        if (this.form) {
          this.form.removeEventListener('input', this.checkQuantities);
          this.form.removeEventListener('change', this.checkQuantities);
          this.form.removeEventListener('click', this.onCartClick);
          this.form.removeEventListener('submit', this.onSubmit, true);
          if (this.checkout) this.checkout.removeEventListener('click', this.onCheckout);
          if (window.jQuery) window.jQuery(this.form).off('change.ymShippingChoice', this.checkQuantities);
        }
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('ym:shipping-ready', this.onServiceReady);
        this.initialized = false;
        this.form = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-shipping-launch-runtime"] && !Shopify.designMode) return;
  try {
    if (!window.YMShipping) {
    const config = document.querySelector('[data-ym-shipping-config]');
    if (config) {
      const cartUrl = new URL(config.dataset.cartUrl, window.location.origin);
      const modeKey = 'ym_shipping_mode';
      const resetAttributes = { ym_shipping_mode: 'together', ym_shipping_preference: 'together', ym_backorder_acknowledged: '', ym_shipping_stock_state: '', ym_has_backorder: 'yes', ym_cod_eligibility_v1: 'blocked' };
      let queue = Promise.resolve();
      let invalidation = null;
      let sequence = 0;
      const replay = new WeakSet();
      function fingerprint(cart) {
        if (!cart || !Array.isArray(cart.items) || typeof cart.currency !== 'string') throw new Error('INVALID_CART');
        const items = cart.items.map((item) => {
          const variant = String(item.variant_id || item.id);
          const plan = String(item.selling_plan_id || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || 0);
          if (typeof item.key !== 'string' || !/^\d+$/.test(variant) || !/^\d+$/.test(plan) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0 || typeof item.requires_shipping !== 'boolean') throw new Error('INVALID_LINE');
          return [item.key, variant, item.quantity, item.final_line_price, plan, item.requires_shipping];
        }).sort((a, b) => a[0].localeCompare(b[0]));
        const subtotal = items.reduce((sum, item) => sum + item[3], 0);
        if (!Number.isSafeInteger(subtotal)) throw new Error('INVALID_SUBTOTAL');
        return JSON.stringify([cart.currency, subtotal, items]);
      }
      function validateState(state) {
        if (!state || state.version !== 1) throw new Error('INVALID_STATE');
        fingerprint(state);
        for (const key of ['ready', 'waiting', 'unknown', 'item_count']) if (!Number.isSafeInteger(state[key]) || state[key] < 0) throw new Error('INVALID_COUNTS');
        if (state.items.reduce((sum, item) => sum + item.quantity, 0) !== state.item_count) throw new Error('INCOMPLETE_CART');
        if (state.items.reduce((sum, item) => sum + (item.requires_shipping ? item.quantity : 0), 0) !== state.ready + state.waiting + state.unknown) throw new Error('INVALID_CLASSIFICATION');
        const expected = state.ready > 0 && state.waiting > 0 && state.unknown === 0 ? 'mixed' : 'single';
        if (state.gate !== expected) throw new Error('INVALID_GATE');
        return state;
      }
      function sameReview(left, right) {
        return fingerprint(left) === fingerprint(right) && ['gate', 'ready', 'waiting', 'unknown'].every((key) => left[key] === right[key]);
      }
      function run(task) {
        const next = queue.then(task, task);
        queue = next.catch(() => {});
        return next;
      }
      async function request(url, options = {}) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
          if (!response.ok) throw new Error('HTTP_' + response.status);
          return options.html ? response.text() : response.json();
        } finally { clearTimeout(timeout); }
      }
      function update(payload) {
        return request(cartUrl.pathname + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      }
      async function reset() {
        const cart = await update({ attributes: resetAttributes });
        if (!cart.attributes || cart.attributes[modeKey] !== 'together' || cart.attributes.ym_has_backorder !== 'yes' || cart.attributes.ym_cod_eligibility_v1 !== 'blocked') throw new Error('RESET_NOT_SAVED');
        return cart;
      }
      function invalidate() {
        if (!invalidation) invalidation = run(reset).finally(() => { invalidation = null; });
        return invalidation;
      }
      async function freshState() {
        const url = new URL(cartUrl);
        url.searchParams.set('view', 'ym-shipping-state');
        url.searchParams.set('_ym', Date.now() + '-' + (++sequence));
        const html = await request(url.href, { html: true });
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ym-stock-state]');
        if (!node) throw new Error('STATE_NOT_RENDERED');
        return validateState(JSON.parse(node.textContent));
      }
      async function handoff(reviewed, preference, acknowledged, note) {
        return run(async () => {
          try {
          await reset();
          const fresh = await freshState();
          if (!sameReview(reviewed, fresh)) throw new Error('REVIEW_CHANGED');
          if (!fresh.items.length) throw new Error('EMPTY_CART');
          if (fresh.waiting > 0 && !acknowledged) throw new Error('ACK_REQUIRED');
          if (!['together', 'separate'].includes(preference)) throw new Error('INVALID_MODE');
          if (preference === 'separate' && (fresh.gate !== 'mixed' || !acknowledged)) throw new Error('SEPARATE_NOT_ALLOWED');
          const attributes = { ym_shipping_mode: preference, ym_shipping_preference: preference, ym_backorder_acknowledged: fresh.waiting > 0 && acknowledged ? 'confirmed' : '', ym_shipping_stock_state: fresh.gate, ym_has_backorder: fresh.waiting > 0 || fresh.unknown > 0 ? 'yes' : 'no', ym_cod_eligibility_v1: fresh.ready > 0 && fresh.waiting === 0 && fresh.unknown === 0 ? 'verified_in_stock' : 'blocked' };
          const payload = { attributes };
          if (typeof note === 'string') payload.note = note;
          const saved = await update(payload);
          if (fingerprint(saved) !== fingerprint(fresh)) throw new Error('CART_CHANGED_DURING_SAVE');
          if (!saved.attributes || Object.entries(attributes).some(([key, value]) => (saved.attributes[key] || '') !== value)) throw new Error('ATTRIBUTES_NOT_SAVED');
          return { ...fresh, attributes };
          } catch (error) {
            try { await reset(); } catch (_) {}
            throw error;
          }
        });
      }
      async function saveCart(updates, note) {
        return run(async () => {
          for (const quantity of Object.values(updates)) if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error('INVALID_QUANTITY');
          const payload = { updates, attributes: resetAttributes };
          if (typeof note === 'string') payload.note = note;
          const saved = await update(payload);
          if (!saved.attributes || saved.attributes[modeKey] !== 'together' || saved.attributes.ym_has_backorder !== 'yes' || saved.attributes.ym_cod_eligibility_v1 !== 'blocked') throw new Error('RESET_NOT_SAVED');
          return saved;
        });
      }
      function canonicalAttributes(form, attributes) {
        for (const [key, value] of Object.entries(attributes)) {
          const inputs = Array.from(document.querySelectorAll('[name="attributes[' + key + ']"]'));
          let input = inputs.shift();
          inputs.forEach((extra) => extra.removeAttribute('name'));
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'attributes[' + key + ']'; form.appendChild(input); }
          input.value = value;
        }
        for (const appCart of [window.wh_data && window.wh_data.wh_cart, window.wcp_data && window.wcp_data.wcp_cart]) {
          if (!appCart) continue;
          appCart.attributes = { ...(appCart.attributes || {}), ...attributes };
          const previous = Array.isArray(appCart.note_attributes) ? appCart.note_attributes.filter((attribute) => !Object.hasOwn(attributes, attribute.name)) : [];
          appCart.note_attributes = previous.concat(Object.entries(attributes).map(([name, value]) => ({ name, value })));
        }
      }
      const service = { cartUrl: cartUrl.href, fingerprint, validateState, sameReview, invalidate, handoff, saveCart, canonicalAttributes, resetLocalAttributes: form => canonicalAttributes(form, resetAttributes), allowOriginalOnce: target => replay.add(target), checkoutBusy: false };
      window.YMShipping = service;
      function showError(target) {
        const scope = target.closest('form') || target.parentElement || document.body;
        let error = scope.querySelector('[data-ym-request-error]');
        if (!error) { error = document.createElement('p'); error.setAttribute('data-ym-request-error', ''); error.setAttribute('role', 'alert'); scope.appendChild(error); }
        error.textContent = config.dataset.error;
      }
      function changed() {
        document.querySelectorAll('ym-shipping-choice:not([data-demo])').forEach((choice) => choice.invalidateChoice && choice.invalidateChoice(false, true));
      }
      function pathOf(value) {
        try { return new URL(value, window.location.origin).pathname; } catch (_) { return ''; }
      }
      document.addEventListener('click', async (event) => {
        const target = event.target.closest('button,input,a');
        if (!target) return;
        if (replay.has(target)) { replay.delete(target); return; }
        const href = target.getAttribute('href');
        const path = href ? pathOf(href) : '';
        const isDirectCheckout = /\/(checkout|checkouts)(\/|$)/.test(path) || ['checkout', 'goto_pp', 'goto_gc'].includes(target.name);
        const guardedChoice = document.querySelector('ym-shipping-choice:not([data-demo])');
        if (guardedChoice && (isDirectCheckout || target.matches('#wh-30-open,.wcp_checkout_btn,.wds_checkout_btn'))) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (!service.checkoutBusy && guardedChoice.beginCheckout) guardedChoice.beginCheckout(target);
          return;
        }
        if (isDirectCheckout && !target.hasAttribute('data-ym-checkout')) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (service.checkoutBusy) return;
          try { await invalidate(); window.location.assign(cartUrl.href); } catch (_) { showError(target); }
          return;
        }
        const productAdd = target.matches('.product-form__cart-submit') && target.closest('form');
        const cartMutation = target.matches('[data-cart-remove],[data-cart-update],[rv-data-cart-remove],[rv-data-cart-update]') || /\/cart\/(change|clear)$/.test(path);
        if (!productAdd && !cartMutation) return;
        if (target.disabled) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (service.checkoutBusy || target.dataset.ymPending === 'true') return;
        target.dataset.ymPending = 'true';
        try {
          await invalidate();
          changed();
          if (/\/cart\/(change|clear)$/.test(path)) window.location.assign(new URL(href, window.location.origin).href);
          else { replay.add(target); target.click(); }
        } catch (_) { showError(target); }
        finally { delete target.dataset.ymPending; }
      }, true);
      document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-ym-cart-form') || form.hasAttribute('data-ym-checkout-only')) return;
        if (replay.has(form)) { replay.delete(form); return; }
        if (form.matches('#net-order-form,#wpdNetMainForm')) {
          const choice = document.querySelector('ym-shipping-choice:not([data-demo])');
          if (choice && choice.beginCheckout) {
            event.preventDefault(); event.stopImmediatePropagation();
            if (!service.checkoutBusy) choice.beginCheckout(form, event.submitter);
          }
          return;
        }
        const path = pathOf(form.action);
        if (!/\/cart\/(add|change|clear)$/.test(path)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        if (service.checkoutBusy || form.dataset.ymPending === 'true') return;
        form.dataset.ymPending = 'true';
        try {
          await invalidate();
          changed();
          replay.add(form);
          form.requestSubmit(event.submitter || undefined);
        } catch (_) { showError(form); }
        finally { delete form.dataset.ymPending; }
      }, true);
      if (window.jQuery) {
        window.jQuery(document).on('ajaxComplete.ymShippingLaunch', (_event, response, settings) => {
          if (!settings || !/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(settings.url) || response.status >= 400) return;
          changed();
          invalidate().catch(() => {});
        });
      }
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) { service.checkoutBusy = false; changed(); service.ready = invalidate(); service.ready.catch(() => {}); }
      });
      service.ready = invalidate();
      service.ready.catch(() => {});
      document.dispatchEvent(new CustomEvent('ym:shipping-ready'));
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-stock-warning-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ym-product-stock-warning')) {
    customElements.define('ym-product-stock-warning', class extends HTMLElement {
      connectedCallback() {
        if (this.form) return;
        this.form = this.closest('form');
        if (!this.form) return;
        this.panel = this.querySelector('[data-stock-warning]');
        this.message = this.querySelector('[data-stock-message]');
        this.variants = Array.from(this.querySelectorAll('[data-stock-variant]'), (node) => ({
          id: node.dataset.stockVariant,
          stock: Number(node.dataset.stock),
          cartQuantity: Number(node.dataset.cartQuantity),
          status: node.dataset.status,
          schema: node.dataset.schema,
          eligible: node.dataset.tracked === 'true' && node.dataset.policy === 'continue' && node.dataset.physical === 'true' && node.dataset.available === 'true',
          options: JSON.parse(node.dataset.options)
        }));
        this.queueUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateWarning());
        };
        this.form.addEventListener('input', this.queueUpdate);
        this.form.addEventListener('change', this.queueUpdate);
        this.form.addEventListener('click', this.queueUpdate);
        this.form.addEventListener('submit', this.queueUpdate);
        this.onQuantityClick = (event) => this.adjustQuantity(event);
        this.form.addEventListener('click', this.onQuantityClick, true);
        this.container = this.closest('[data-section-type]') || this.form;
        if (window.jQuery) {
          window.jQuery(this.form).on('change.ymStockWarning', this.queueUpdate);
          window.jQuery(this.container).on('variantChange.ymStockWarning', this.queueUpdate);
        }
        this.queueUpdate();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (!this.form) return;
        ['input', 'change', 'click', 'submit'].forEach((name) => this.form.removeEventListener(name, this.queueUpdate));
        this.form.removeEventListener('click', this.onQuantityClick, true);
        if (window.jQuery) {
          window.jQuery(this.form).off('change.ymStockWarning', this.queueUpdate);
          window.jQuery(this.container).off('variantChange.ymStockWarning', this.queueUpdate);
        }
        this.form = null;
      }
      adjustQuantity(event) {
        const button = event.target.closest('.qtyBtn');
        if (!button || !this.form.contains(button)) return;
        const field = button.closest('.qtyField');
        const input = field && field.querySelector('[name="quantity"]');
        if (!input) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const current = Number(input.value);
        const next = Math.max(1, (Number.isInteger(current) && current > 0 ? current : 1) + (button.classList.contains('plus') ? 1 : -1));
        const maximum = Number(input.getAttribute('max'));
        input.value = String(input.hasAttribute('max') && Number.isFinite(maximum) && maximum > 0 ? Math.min(next, maximum) : next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.queueUpdate();
      }
      updateWarning() {
        const master = this.form.querySelector('[name="id"]');
        let variant = this.variants.find((entry) => entry.id === String(master ? master.value : this.dataset.selected));
        const selectors = Array.from(this.form.querySelectorAll('.single-option-selector[data-index]'));
        if (selectors.length) {
          const options = variant ? variant.options.slice() : [];
          selectors.forEach((input) => { options[Number(input.dataset.index.replace('option', '')) - 1] = input.value; });
          variant = this.variants.find((entry) => entry.options.every((value, index) => value === options[index]));
        }
        const input = this.form.querySelector('[name="quantity"]');
        const quantity = Number(input ? input.value : 1);
        let cartQuantity = variant ? variant.cartQuantity : 0;
        if (variant && window.CartJS && window.CartJS.cart && Array.isArray(window.CartJS.cart.items)) {
          cartQuantity = window.CartJS.cart.items.reduce((total, item) => total + (String(item.variant_id || item.id) === variant.id ? Number(item.quantity) : 0), 0);
        }
        const waiting = Boolean(variant && variant.eligible && Number.isInteger(quantity) && quantity > 0 && quantity + cartQuantity > variant.stock);
        this.panel.hidden = !waiting;
        this.message.textContent = waiting ? (variant.stock === 0 ? this.dataset.out : this.dataset.partial) : '';
        this.updateStockStatus(variant);
      }
      updateStockStatus(variant) {
        if (!this.container) return;
        this.container.querySelectorAll('[data-ym-stock-status]').forEach((status) => {
          if (status.dataset.productId !== this.dataset.productId) return;
          status.textContent = variant ? variant.status : status.dataset.unavailable;
        });
        this.container.querySelectorAll('[data-ym-stock-schema]').forEach((holder) => {
          if (holder.dataset.productId !== this.dataset.productId) return;
          holder.replaceChildren();
          if (variant && variant.schema) {
            const link = document.createElement('link');
            link.setAttribute('itemprop', 'availability');
            link.setAttribute('href', variant.schema);
            holder.appendChild(link);
          }
        });
      }
    });
  }
  if (window.jQuery && !window.ymStockAjaxListener) {
    window.ymStockAjaxListener = true;
    window.jQuery(document).on('ajaxComplete.ymStockWarning', (_event, response, settings) => {
      if (!settings || !/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(settings.url) || response.status >= 400) return;
      document.querySelectorAll('ym-product-stock-warning').forEach((warning) => warning.queueUpdate && warning.queueUpdate());
      document.querySelectorAll('ym-shipping-choice:not([data-demo])').forEach((choice) => choice.invalidateChoice && choice.invalidateChoice());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
